@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="my-jobs-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <header>
        <div class="title">
            <lucide-angular name="videotape" size="44"></lucide-angular>
            <h1>{{ 'nav.my_videos.title' | translate }}</h1>
            <span>({{jobsCount$ | async}})</span>
        </div>
        <div class="filters">
            <p>{{ 'common.sort_by' | translate }}</p>
            <div class="filter" [ngClass]="{'selected': selectedSortType === 'status'}" (click)="sortBy('status')">{{'my_jobs.filters.status' | translate}}</div>
            <div class="filter" [ngClass]="{'selected': selectedSortType === 'created_at'}"
                (click)="sortBy('created_at')">{{'my_jobs.filters.date' | translate}}</div>
            <div class="filter" [ngClass]="{'selected': selectedSortType === 'task'}" (click)="sortBy('task')">{{'my_jobs.filters.task_type' | translate}}</div>
        </div>
    </header>

    @if(( jobsCount$ | async) === 0){
    <div class="no-job">
        <h2>{{ 'my_jobs.no_job_title' | translate }}</h2>
        <p>{{ 'my_jobs.no_job' | translate }}</p>
        <app-button [routerLink]="'/dashboard/create-job'">{{ 'my_jobs.buttons.add_video' | translate }}</app-button>
    </div>
    }
    @else{
    <div id="jobs-container">
        @for(job of (jobs$ | async); track $index){
        <app-job-row [job]="job" (onClick)="navigateToJob($event.id)"></app-job-row>
        }
    </div>
    }
</div>